import React, { ReactNode } from 'react';
import { QueryClient, QueryClientProvider, Hydrate } from 'react-query';

type QueryProviderProps = {
  pageProps: any;
  children: ReactNode;
};

const queryClient = new QueryClient();

const QueryProvider = ({ children, pageProps }: QueryProviderProps) => {
  return (
    <QueryClientProvider client={queryClient}>
      <Hydrate state={pageProps.dehydratedState}>
        {/* <ReactQueryDevtools initialIsOpen={false} /> */}
        <div>{children}</div>
      </Hydrate>
    </QueryClientProvider>
  );
};

export default QueryProvider;
